module.exports = __webpack_public_path__ + "img/WESicon1.9a5f2fd6.png";